import { render, staticRenderFns } from "./LineHeight.vue?vue&type=template&id=20a7e454&"
import script from "./LineHeight.vue?vue&type=script&lang=ts&"
export * from "./LineHeight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports